import { render } from "./PackagePlanningsInput.vue?vue&type=template&id=c721d36c"
import script from "./PackagePlanningsInput.vue?vue&type=script&lang=js"
export * from "./PackagePlanningsInput.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/package_planning.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Falejo%2FDevelopment%2FAT%2FApps%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fproduction%2Fbasic_container_export%2Fcontainer_planning%2FPackagePlanningsInput.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__